package com.shadowings.gero.presentation.screen

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.LessonIds
import com.shadowings.gero.domain.model.ThemeMode
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.domain.reminder.openExactAlarmPermissionSettings
import com.shadowings.gero.domain.reminder.openNotificationPermissionSettings
import com.shadowings.gero.domain.reminder.rememberExactAlarmPermissionGranted
import com.shadowings.gero.domain.reminder.rememberNotificationPermissionGranted
import com.shadowings.gero.getPlatform
import com.shadowings.gero.presentation.component.FeatureUnavailableDialog
import com.shadowings.gero.presentation.component.NativeTimePickerDialog
import com.shadowings.gero.presentation.component.avatars.InteractiveAvatar
import com.shadowings.gero.presentation.component.avatars.NiloAvatar
import com.shadowings.gero.presentation.model.ProfileUiState
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import com.shadowings.gero.presentation.util.rememberFeedbackDebugInfo
import com.shadowings.gero.presentation.viewmodel.ProfileViewModel
import com.shadowings.gero.presentation.widget.rememberAddStrikeWidgetAction
import com.shadowings.gero.util.FeedbackEmail
import com.shadowings.gero.util.FeedbackType
import com.shadowings.gero.util.getAppVersionName
import com.shadowings.gero.util.rememberFeedbackSender
import com.shadowings.gero.util.systemLanguageCode
import compose.icons.FeatherIcons
import compose.icons.feathericons.ChevronRight
import compose.icons.feathericons.Cloud
import compose.icons.feathericons.RefreshCw
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.add_coins_btn
import gero.composeapp.generated.resources.add_hearts_btn
import gero.composeapp.generated.resources.add_stars_btn
import gero.composeapp.generated.resources.audio_settings_desc
import gero.composeapp.generated.resources.audio_settings_title
import gero.composeapp.generated.resources.cancel
import gero.composeapp.generated.resources.clear_wrong_answers_btn
import gero.composeapp.generated.resources.cta_complete
import gero.composeapp.generated.resources.cta_complete_btn
import gero.composeapp.generated.resources.cta_restore
import gero.composeapp.generated.resources.cta_restore_btn
import gero.composeapp.generated.resources.feedback_general_subject
import gero.composeapp.generated.resources.feedback_general_template
import gero.composeapp.generated.resources.haptic_settings_desc
import gero.composeapp.generated.resources.haptic_settings_title
import gero.composeapp.generated.resources.hide_options_desc
import gero.composeapp.generated.resources.hide_options_title
import gero.composeapp.generated.resources.language_desc
import gero.composeapp.generated.resources.language_title
import gero.composeapp.generated.resources.login_btn
import gero.composeapp.generated.resources.logout_btn
import gero.composeapp.generated.resources.privacy_policy_label
import gero.composeapp.generated.resources.profile_cloud_save
import gero.composeapp.generated.resources.profile_credits_bug_reports
import gero.composeapp.generated.resources.profile_credits_dev
import gero.composeapp.generated.resources.profile_credits_image_note
import gero.composeapp.generated.resources.profile_credits_image_sources
import gero.composeapp.generated.resources.profile_credits_sources
import gero.composeapp.generated.resources.profile_credits_title
import gero.composeapp.generated.resources.profile_cta_changelog_button
import gero.composeapp.generated.resources.profile_cta_changelog_text
import gero.composeapp.generated.resources.profile_cta_feedback_button
import gero.composeapp.generated.resources.profile_cta_feedback_text
import gero.composeapp.generated.resources.profile_cta_more_apps_button
import gero.composeapp.generated.resources.profile_cta_more_apps_text
import gero.composeapp.generated.resources.profile_cta_rate_button
import gero.composeapp.generated.resources.profile_cta_rate_text
import gero.composeapp.generated.resources.profile_debug_actions_title
import gero.composeapp.generated.resources.profile_default_user
import gero.composeapp.generated.resources.profile_save_cloud_hint
import gero.composeapp.generated.resources.profile_status_synced
import gero.composeapp.generated.resources.profile_status_unsynced
import gero.composeapp.generated.resources.profile_theme_dark
import gero.composeapp.generated.resources.profile_theme_desc
import gero.composeapp.generated.resources.profile_theme_light
import gero.composeapp.generated.resources.profile_theme_system
import gero.composeapp.generated.resources.profile_theme_title
import gero.composeapp.generated.resources.profile_title
import gero.composeapp.generated.resources.profile_widget_add_button
import gero.composeapp.generated.resources.profile_widget_desc
import gero.composeapp.generated.resources.profile_widget_title
import gero.composeapp.generated.resources.reminder_exact_alarm_desc
import gero.composeapp.generated.resources.reminder_open_exact_alarm_settings
import gero.composeapp.generated.resources.reminder_open_permissions
import gero.composeapp.generated.resources.reminder_settings_choose
import gero.composeapp.generated.resources.reminder_settings_title
import gero.composeapp.generated.resources.reminder_settings_toggle_desc
import gero.composeapp.generated.resources.remove_hearts_btn
import gero.composeapp.generated.resources.reset_data_btn
import gero.composeapp.generated.resources.reset_data_confirm
import gero.composeapp.generated.resources.reset_data_dialog_text
import gero.composeapp.generated.resources.reset_data_dialog_title
import gero.composeapp.generated.resources.shop
import gero.composeapp.generated.resources.terms_and_conditions_label
import gero.composeapp.generated.resources.test_mode_desc
import gero.composeapp.generated.resources.test_mode_title
import gero.composeapp.generated.resources.unlock_all_lessons_btn
import gero.composeapp.generated.resources.unlock_up_to_chapter_9_btn
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
fun ProfileScreenPreview() {
    AppTheme {
        Surface {
            ProfileScreenContent(
                uiState = ProfileUiState(
                    testMode = false,
                    userData = UserData(
                        stars = mapOf("lesson_1" to 3, "lesson_2" to 2),
                        perfect = setOf("lesson_1"),
                        explanations = setOf("lesson_1", "lesson_3"),
                        experience = 42,
                        tutorialDone = true
                    )
                ),
                onTestModeToggle = {},
                onResetData = {},
                onAddStars = {},
                onUnlockAllLessons = {},
                onUnlockLessonsUpToChapter9 = {},
                onClearWrongAnswers = {},
                onAddHearts = {},
                onAddExperience = {},
                onRemoveHearts = {},
                onAuthClick = {},
                onFeaturePollClick = {},
                onSignOut = {},
                onLanguageChange = {},
                onThemeModeChange = {},
                onReminderEnabledChange = {},
                onReminderTimeChange = { _, _ -> },
                onUnlockCheats = {},
                onSoundEnabledChange = {},
                onHapticEnabledChange = {},
                onHideOptionsChange = {},
                onPurchaseFullVersion = {},
                onRestorePurchases = {},
                isFullVersionUnlocked = false,
            )
        }
    }
}

@Composable
fun ProfileScreen(
    onAuthClick: () -> Unit,
    onFeaturePollClick: () -> Unit,
    onPurchaseFullVersion: () -> Unit,
    onRestorePurchases: () -> Unit,
    isFullVersionUnlocked: Boolean,
    modifier: Modifier = Modifier,
    viewModel: ProfileViewModel = koinViewModel(),
) {
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()

    ProfileScreenContent(
        uiState = uiState,
        onTestModeToggle = { viewModel.setTestMode(it) },
        onResetData = { viewModel.resetData() },
        onAddStars = { viewModel.addStars() },
        onUnlockAllLessons = { viewModel.unlockAllLessons() },
        onUnlockLessonsUpToChapter9 = { viewModel.unlockLessonsUpToChapter9() },
        onClearWrongAnswers = { viewModel.clearWrongAnswers() },
        onAddHearts = { viewModel.addHearts(10) },
        onAddExperience = { viewModel.addExperience(10) },
        onRemoveHearts = { viewModel.removeHearts() },
        onAuthClick = onAuthClick,
        onFeaturePollClick = onFeaturePollClick,
        onSignOut = { viewModel.signOut() },
        onLanguageChange = { viewModel.setLanguage(it) },
        onThemeModeChange = { viewModel.setThemeMode(it) },
        onSoundEnabledChange = { viewModel.setSoundEnabled(it) },
        onHapticEnabledChange = { viewModel.setHapticEnabled(it) },
        onHideOptionsChange = { viewModel.setHideOptions(it) },
        onReminderEnabledChange = { viewModel.setReminderEnabled(it) },
        onReminderTimeChange = { hour, minute -> viewModel.setReminderTime(hour, minute) },
        onUnlockCheats = { viewModel.unlockCheats() },
        onPurchaseFullVersion = onPurchaseFullVersion,
        onRestorePurchases = onRestorePurchases,
        isFullVersionUnlocked = isFullVersionUnlocked,
        modifier = modifier,
    )
}

@Composable
fun ProfileScreenContent(
    uiState: ProfileUiState,
    onTestModeToggle: (Boolean) -> Unit,
    onResetData: () -> Unit,
    onAddStars: () -> Unit,
    onUnlockAllLessons: () -> Unit,
    onUnlockLessonsUpToChapter9: () -> Unit,
    onClearWrongAnswers: () -> Unit,
    onAddHearts: () -> Unit,
    onAddExperience: () -> Unit,
    onRemoveHearts: () -> Unit,
    onAuthClick: () -> Unit,
    onFeaturePollClick: () -> Unit,
    onSignOut: () -> Unit,
    onLanguageChange: (String) -> Unit,
    onThemeModeChange: (ThemeMode) -> Unit,
    onSoundEnabledChange: (Boolean) -> Unit,
    onHapticEnabledChange: (Boolean) -> Unit,
    onHideOptionsChange: (Boolean) -> Unit,
    onReminderEnabledChange: (Boolean) -> Unit,
    onReminderTimeChange: (Int, Int) -> Unit,
    onUnlockCheats: () -> Unit,
    onPurchaseFullVersion: () -> Unit,
    onRestorePurchases: () -> Unit,
    isFullVersionUnlocked: Boolean = false,
    modifier: Modifier = Modifier
) {
    val deviceInfo = rememberDeviceInfo()
    val showResetDialog = remember { mutableStateOf(false) }
    val hapticFeedback = LocalHapticFeedback.current
    var creditsTapCount by rememberSaveable { mutableStateOf(0) }
    val creditsTapInteractionSource = remember { MutableInteractionSource() }
    val userData = uiState.userData
    val showCheats = uiState.showCheats
    val testMode = uiState.testMode
    val themeMode = uiState.themeMode
    val reminderEnabled = uiState.reminderEnabled
    val soundEnabled = uiState.soundEnabled
    val hapticEnabled = uiState.hapticEnabled
    val hideOptions = uiState.hideOptions
    val reminderHour = uiState.reminderHour
    val reminderMinute = uiState.reminderMinute
    val notificationsGranted = rememberNotificationPermissionGranted()
    val exactAlarmPermissionGranted = rememberExactAlarmPermissionGranted()
    var showTimePickerDialog by remember { mutableStateOf(false) }
    var showFeatureUnavailableDialog by remember { mutableStateOf(false) }
    val addStrikeWidgetAction = rememberAddStrikeWidgetAction()
    val isWeb = getPlatform().isWeb

    if (showTimePickerDialog) {
        NativeTimePickerDialog(
            hour = reminderHour,
            minute = reminderMinute,
            onTimePicked = { h, m ->
                onReminderTimeChange(h, m)
                showTimePickerDialog = false
            },
            onDismiss = { showTimePickerDialog = false }
        )
    }

    if (showFeatureUnavailableDialog) {
        FeatureUnavailableDialog(onDismiss = { showFeatureUnavailableDialog = false })
    }
    val uriHandler = LocalUriHandler.current
    val selectedLanguage = userData.language.ifBlank { systemLanguageCode() }
    val legalLanguageSuffix = when {
        selectedLanguage.startsWith("it") -> "it"
        selectedLanguage.startsWith("de") -> "de"
        selectedLanguage.startsWith("es") -> "es"
        selectedLanguage.startsWith("fr") -> "fr"
        else -> "en"
    }
    val privacyPolicyUrl =
        "https://emmanuelevilla.com/miulingo/privacy_policy_${legalLanguageSuffix}.html"
    val termsAndConditionsUrl =
        "https://emmanuelevilla.com/miulingo/terms_and_conditions_${legalLanguageSuffix}.html"
    val sendFeedback = rememberFeedbackSender()
    val feedbackDebugInfo = rememberFeedbackDebugInfo(FeedbackType.GENERAL)
    val feedbackSubject = stringResource(Res.string.feedback_general_subject)
    val feedbackTemplate = stringResource(Res.string.feedback_general_template)
    val rateAppUrl = com.shadowings.gero.util.getRateAppUrl()
    val otherAppsUrl = "https://play.google.com/store/apps/dev?id=7105926093148957846"

    if (showResetDialog.value) {
        AlertDialog(
            onDismissRequest = { showResetDialog.value = false },
            title = {
                Text(
                    text = stringResource(Res.string.reset_data_dialog_title),
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold)
                )
            },
            text = {
                Text(
                    text = stringResource(Res.string.reset_data_dialog_text),
                    style = MaterialTheme.typography.bodyMedium
                )
            },
            confirmButton = {
                TextButton(
                    onClick = {
                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                        onResetData()
                        showResetDialog.value = false
                    },
                    modifier = Modifier.semantics { testTag = "profile_btn_reset_confirm" }
                ) {
                    Text(
                        text = stringResource(Res.string.reset_data_confirm),
                        color = MaterialTheme.colorScheme.error
                    )
                }
            },
            dismissButton = {
                TextButton(
                    onClick = {
                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                        showResetDialog.value = false
                    },
                    modifier = Modifier.semantics { testTag = "profile_btn_reset_cancel" }
                ) {
                    Text(text = stringResource(Res.string.cancel))
                }
            }
        )
    }

    Column(
        modifier = modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(horizontal = 24.dp, vertical = 16.dp)
            .semantics { testTag = "profile_screen" },
        verticalArrangement = Arrangement.Top
    ) {
        Text(
            text = stringResource(Res.string.profile_title),
            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.semantics { testTag = "profile_title" }
        )

        Spacer(Modifier.height(16.dp))

        // ── Card Cloud Save & Sincronizzazione ──
        Card(
            modifier = Modifier.fillMaxWidth(),
            shape = RoundedCornerShape(16.dp),
            colors = CardDefaults.cardColors(
                containerColor = MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.25f)
            ),
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary.copy(alpha = 0.25f))
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(16.dp)
                ) {

                    if (deviceInfo.deviceClass != DeviceClass.PHONE_SMALL) {
                        val syncIcon =
                            if (uiState.isSyncing) FeatherIcons.RefreshCw else FeatherIcons.Cloud
                        Icon(
                            imageVector = syncIcon,
                            contentDescription = null,
                            tint = MaterialTheme.colorScheme.primary,
                            modifier = Modifier.size(32.dp)
                        )
                    }

                    Column(modifier = Modifier.weight(1f)) {
                        Text(
                            text = stringResource(Res.string.profile_cloud_save),
                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                            color = MaterialTheme.colorScheme.onSurface
                        )

                        if (uiState.isLoggedIn) {
                            Text(
                                text = stringResource(Res.string.profile_status_synced),
                                style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.SemiBold),
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(Modifier.height(2.dp))
                            Text(
                                text = uiState.userEmail
                                    ?: stringResource(Res.string.profile_default_user),
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                            )
                        } else {
                            Text(
                                text = stringResource(Res.string.profile_status_unsynced),
                                style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.SemiBold),
                                color = MaterialTheme.colorScheme.error
                            )
                            Spacer(Modifier.height(2.dp))
                            Text(
                                text = stringResource(Res.string.profile_save_cloud_hint),
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                            )
                        }
                    }

                    if (uiState.isLoggedIn) {
                        SettingsActionButton(
                            title = stringResource(Res.string.logout_btn),
                            modifier = Modifier.width(90.dp),
                            backgroundColor = MaterialTheme.colorScheme.errorContainer,
                            borderColor = MaterialTheme.colorScheme.error,
                            textColor = MaterialTheme.colorScheme.onErrorContainer,
                            onClick = onSignOut
                        )
                    } else {
                        SettingsActionButton(
                            title = stringResource(Res.string.login_btn),
                            modifier = Modifier.width(95.dp),
                            backgroundColor = MaterialTheme.colorScheme.primaryContainer,
                            borderColor = MaterialTheme.colorScheme.primary,
                            textColor = MaterialTheme.colorScheme.onPrimaryContainer,
                            onClick = onAuthClick
                        )
                    }
                }



                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    LegalLinkBox(
                        label = stringResource(Res.string.privacy_policy_label),
                        modifier = Modifier.then(
                            if (deviceInfo.isPhone) Modifier.weight(1f) else Modifier.width(250.dp)
                        ),
                        testTagId = "profile_btn_privacy",
                        onClick = {
                            try {
                                uriHandler.openUri(privacyPolicyUrl)
                            } catch (e: Exception) {
                                println("Failed to open privacy policy: ${e.message}")
                            }
                        }
                    )
                    LegalLinkBox(
                        label = stringResource(Res.string.terms_and_conditions_label),
                        modifier = Modifier.then(
                            if (deviceInfo.isPhone) Modifier.weight(1f) else Modifier.width(250.dp)
                        ),
                        testTagId = "profile_btn_terms",
                        onClick = {
                            try {
                                uriHandler.openUri(termsAndConditionsUrl)
                            } catch (e: Exception) {
                                println("Failed to open terms and conditions: ${e.message}")
                            }
                        }
                    )
                }
            }
        }

        if (!isFullVersionUnlocked) {
            val shopAvatarSize = if (deviceInfo.deviceClass == DeviceClass.PHONE_SMALL) {
                48.dp
            } else {
                56.dp
            }

            Spacer(Modifier.height(24.dp))
            HorizontalDivider()
            Spacer(Modifier.height(16.dp))
            Text(
                text = stringResource(Res.string.shop),
                style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                color = MaterialTheme.colorScheme.onSurface
            )
            Spacer(Modifier.height(12.dp))
            ProfileCtaItem(
                text = stringResource(Res.string.cta_complete),
                actionLabel = stringResource(Res.string.cta_complete_btn),
                avatar = {
                    NiloAvatar(
                        userData = userData,
                        face = Faces.Idle,
                        modifier = Modifier.height(shopAvatarSize),
                        withBackground = false
                    )
                },
                onClick = {
                    if (isWeb) {
                        showFeatureUnavailableDialog = true
                    } else {
                        onPurchaseFullVersion()
                    }
                },
                testTagId = "profile_btn_shop_buy_full"
            )

            val isZetaUnlocked = userData.explanations.contains(LessonIds.END_VERB_1)

            Spacer(Modifier.height(12.dp))
            ProfileCtaItem(
                text = stringResource(Res.string.cta_restore),
                actionLabel = stringResource(Res.string.cta_restore_btn),
                avatar = {
                    InteractiveAvatar(
                        character = Characters.Zeta,
                        userData = userData,
                        baseFace = if (isZetaUnlocked) Faces.Idle else Faces.AllBlack,
                        modifier = Modifier.height(shopAvatarSize),
                        withBackground = false
                    )
                },
                onClick = {
                    if (isWeb) {
                        showFeatureUnavailableDialog = true
                    } else {
                        onRestorePurchases()
                    }
                },
                testTagId = "profile_btn_shop_restore"
            )
        }

        Spacer(Modifier.height(24.dp))
        HorizontalDivider()
        Spacer(Modifier.height(16.dp))

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = stringResource(Res.string.language_title),
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                    color = MaterialTheme.colorScheme.onSurface
                )
                Text(
                    text = stringResource(Res.string.language_desc),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                )
            }

            LanguageDropdown(
                selectedLanguage = selectedLanguage,
                onLanguageChange = onLanguageChange
            )
        }

        Spacer(Modifier.height(24.dp))
        HorizontalDivider()
        Spacer(Modifier.height(16.dp))

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = stringResource(Res.string.profile_theme_title),
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                    color = MaterialTheme.colorScheme.onSurface
                )
                Text(
                    text = stringResource(Res.string.profile_theme_desc),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                )
            }

            ThemeModeDropdown(
                selectedTheme = themeMode,
                onThemeModeChange = onThemeModeChange
            )
        }

        Spacer(Modifier.height(16.dp))
        HorizontalDivider()
        Spacer(Modifier.height(16.dp))

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = stringResource(Res.string.audio_settings_title),
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                    color = MaterialTheme.colorScheme.onSurface
                )
                Text(
                    text = stringResource(Res.string.audio_settings_desc),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                )
            }

            Switch(
                checked = soundEnabled,
                onCheckedChange = {
                    hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                    onSoundEnabledChange(it)
                },
                colors = SwitchDefaults.colors(
                    checkedThumbColor = MaterialTheme.colorScheme.onPrimary,
                    checkedTrackColor = MaterialTheme.colorScheme.primary,
                    uncheckedThumbColor = MaterialTheme.colorScheme.outline,
                    uncheckedTrackColor = MaterialTheme.colorScheme.surfaceVariant
                )
            )
        }

        if (!isWeb) {
            Spacer(Modifier.height(16.dp))

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = stringResource(Res.string.haptic_settings_title),
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                        color = MaterialTheme.colorScheme.onSurface
                    )
                    Text(
                        text = stringResource(Res.string.haptic_settings_desc),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                    )
                }

                Switch(
                    checked = hapticEnabled,
                    onCheckedChange = {
                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                        onHapticEnabledChange(it)
                    },
                    colors = SwitchDefaults.colors(
                        checkedThumbColor = MaterialTheme.colorScheme.onPrimary,
                        checkedTrackColor = MaterialTheme.colorScheme.primary,
                        uncheckedThumbColor = MaterialTheme.colorScheme.outline,
                        uncheckedTrackColor = MaterialTheme.colorScheme.surfaceVariant
                    )
                )
            }
        }

        Spacer(Modifier.height(16.dp))

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = stringResource(Res.string.hide_options_title),
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                    color = MaterialTheme.colorScheme.onSurface
                )
                Text(
                    text = stringResource(Res.string.hide_options_desc),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                )
            }

            Switch(
                checked = hideOptions,
                onCheckedChange = {
                    hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                    onHideOptionsChange(it)
                },
                colors = SwitchDefaults.colors(
                    checkedThumbColor = MaterialTheme.colorScheme.onPrimary,
                    checkedTrackColor = MaterialTheme.colorScheme.primary,
                    uncheckedThumbColor = MaterialTheme.colorScheme.outline,
                    uncheckedTrackColor = MaterialTheme.colorScheme.surfaceVariant
                )
            )
        }

        if (!isWeb) {
            Spacer(Modifier.height(16.dp))
            HorizontalDivider()
            Spacer(Modifier.height(24.dp))

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = stringResource(Res.string.reminder_settings_title),
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                        color = MaterialTheme.colorScheme.onSurface
                    )

                    Text(
                        text = stringResource(Res.string.reminder_settings_toggle_desc),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                    )
                    if (!notificationsGranted) {
                        Spacer(Modifier.height(8.dp))
                        SettingsActionButton(
                            title = stringResource(Res.string.reminder_open_permissions),
                            modifier = Modifier.align(Alignment.Start),
                            backgroundColor = MaterialTheme.colorScheme.secondaryContainer,
                            borderColor = MaterialTheme.colorScheme.secondary,
                            textColor = MaterialTheme.colorScheme.onSecondaryContainer,
                            onClick = { openNotificationPermissionSettings() }
                        )
                    }
                    if (!exactAlarmPermissionGranted) {
                        Spacer(Modifier.height(8.dp))
                        Text(
                            text = stringResource(Res.string.reminder_exact_alarm_desc),
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.7f)
                        )
                        Spacer(Modifier.height(8.dp))
                        SettingsActionButton(
                            title = stringResource(Res.string.reminder_open_exact_alarm_settings),
                            modifier = Modifier.align(Alignment.Start),
                            backgroundColor = MaterialTheme.colorScheme.secondaryContainer,
                            borderColor = MaterialTheme.colorScheme.secondary,
                            textColor = MaterialTheme.colorScheme.onSecondaryContainer,
                            onClick = { openExactAlarmPermissionSettings() }
                        )
                    }
                }

                Switch(
                    checked = reminderEnabled,
                    onCheckedChange = {
                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                        onReminderEnabledChange(it)
                    },
                    colors = SwitchDefaults.colors(
                        checkedThumbColor = MaterialTheme.colorScheme.onPrimary,
                        checkedTrackColor = MaterialTheme.colorScheme.primary,
                        uncheckedThumbColor = MaterialTheme.colorScheme.outline,
                        uncheckedTrackColor = MaterialTheme.colorScheme.surfaceVariant
                    )
                )
            }

            Spacer(Modifier.height(8.dp))

            // Keyed on the language: none of ReminderTimeButton's own parameters (hour/minute/
            // enabled/onClick/modifier) change when the user switches language, so without this
            // key Compose's strong-skipping would skip re-running its body — and the
            // "reminder_settings_choose" stringResource() inside it would never re-resolve until
            // the whole ProfileScreen got recomposed from scratch (e.g. by navigating away and back).
            key(selectedLanguage) {
                ReminderTimeButton(
                    hour = reminderHour,
                    minute = reminderMinute,
                    enabled = reminderEnabled,
                    onClick = { showTimePickerDialog = true },
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }

        if (addStrikeWidgetAction != null) {

            Spacer(Modifier.height(16.dp))
            HorizontalDivider()
            Spacer(Modifier.height(24.dp))
            Card(
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(16.dp),
                colors = CardDefaults.cardColors(
                    containerColor = MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.25f)
                ),
                border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary.copy(alpha = 0.25f))
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(16.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    Column(modifier = Modifier.weight(1f)) {
                        Text(
                            text = stringResource(Res.string.profile_widget_title),
                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                            color = MaterialTheme.colorScheme.onSurface
                        )
                        Spacer(Modifier.height(4.dp))
                        Text(
                            text = stringResource(Res.string.profile_widget_desc),
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.7f)
                        )
                    }

                    SettingsActionButton(
                        title = stringResource(Res.string.profile_widget_add_button),
                        modifier = Modifier.width(148.dp),
                        backgroundColor = MaterialTheme.colorScheme.primaryContainer,
                        borderColor = MaterialTheme.colorScheme.primary,
                        textColor = MaterialTheme.colorScheme.onPrimaryContainer,
                        testTagId = "profile_btn_add_widget",
                        onClick = addStrikeWidgetAction
                    )
                }
            }
        }

        Spacer(Modifier.height(16.dp))
        HorizontalDivider()
        Spacer(Modifier.height(24.dp))

        val avatarSize = if (deviceInfo.deviceClass == DeviceClass.PHONE_SMALL) {
            48.dp
        } else {
            56.dp
        }

        ProfileCtaItem(
            text = stringResource(Res.string.profile_cta_feedback_text),
            actionLabel = stringResource(Res.string.profile_cta_feedback_button),
            avatar = {
                InteractiveAvatar(
                    character = Characters.Alyn,
                    userData = userData,
                    baseFace = Faces.Happy,
                    modifier = Modifier.height(avatarSize),
                    withBackground = false
                )
            },
            onClick = {
                try {
                    sendFeedback(
                        FeedbackEmail(
                            subject = feedbackSubject,
                            templateBody = feedbackTemplate,
                            debugInfo = feedbackDebugInfo
                        )
                    )
                } catch (e: Exception) {
                    println("Failed to open mail client: ${e.message}")
                }
            },
            testTagId = "profile_btn_feedback"
        )

        if (!isWeb) {
            Spacer(Modifier.height(12.dp))

            ProfileCtaItem(
                text = stringResource(Res.string.profile_cta_rate_text),
                actionLabel = stringResource(Res.string.profile_cta_rate_button),
                avatar = {
                    InteractiveAvatar(
                        character = Characters.Nilo,
                        userData = userData,
                        baseFace = Faces.Idle,
                        modifier = Modifier.height(avatarSize),
                        withBackground = false
                    )
                },
                onClick = {
                    try {
                        uriHandler.openUri(rateAppUrl)
                    } catch (e: Exception) {
                        println("Failed to open rating page: ${e.message}")
                    }
                },
                testTagId = "profile_btn_rate"
            )
        }

        val isZetaUnlocked = userData.explanations.contains(LessonIds.END_VERB_1)

        if (!isWeb) {
            Spacer(Modifier.height(12.dp))

            ProfileCtaItem(
                text = stringResource(Res.string.profile_cta_more_apps_text),
                actionLabel = stringResource(Res.string.profile_cta_more_apps_button),
                avatar = {
                    InteractiveAvatar(
                        character = Characters.Zeta,
                        userData = userData,
                        baseFace = if (isZetaUnlocked) Faces.Idle else Faces.AllBlack,
                        modifier = Modifier.height(avatarSize),
                        withBackground = false
                    )
                },
                onClick = {
                    try {
                        uriHandler.openUri(otherAppsUrl)
                    } catch (e: Exception) {
                        println("Failed to open developer page: ${e.message}")
                    }
                },
                testTagId = "profile_btn_other_apps"
            )
        }

        val isMaskoUnlocked = userData.explanations.contains(LessonIds.ENDING_VSO)
        var showFullChangelog by remember { mutableStateOf(false) }

        Spacer(Modifier.height(12.dp))

        ProfileCtaItem(
            text = stringResource(Res.string.profile_cta_changelog_text),
            actionLabel = stringResource(Res.string.profile_cta_changelog_button),
            avatar = {
                InteractiveAvatar(
                    character = Characters.Masko,
                    userData = userData,
                    baseFace = if (isMaskoUnlocked) Faces.Idle else Faces.AllBlack,
                    modifier = Modifier.height(avatarSize),
                    withBackground = false
                )
            },
            onClick = { showFullChangelog = true },
            testTagId = "profile_btn_changelog"
        )

        if (showFullChangelog) {
            FullChangelogDialog(onDismiss = { showFullChangelog = false })
        }

        Spacer(Modifier.height(24.dp))
        HorizontalDivider()
        Spacer(Modifier.height(16.dp))

        // ── Credits ──
        Text(
            text = stringResource(Res.string.profile_credits_title),
            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.semantics { testTag = "profile_credits_title" }
        )
        Spacer(Modifier.height(8.dp))
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .clickable(
                    interactionSource = creditsTapInteractionSource,
                    indication = null,
                ) {
                    hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                    if (!showCheats) {
                        creditsTapCount += 1
                        if (creditsTapCount >= 9) {
                            onUnlockCheats()
                            creditsTapCount = 0
                        }
                    }
                }
                .semantics { testTag = "profile_card_credits_clickable" },
            shape = RoundedCornerShape(12.dp),
            colors = CardDefaults.cardColors(
                containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.4f)
            ),
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant)
        ) {
            Column(
                modifier = Modifier.padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Text(
                    text = stringResource(Res.string.profile_credits_dev),
                    style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.SemiBold),
                    color = MaterialTheme.colorScheme.primary
                )
                Text(
                    text = "Emmanuele Villa",
                    style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Medium),
                    color = MaterialTheme.colorScheme.onSurface
                )

                HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f))

                val creditSections = listOf(
                    Res.string.profile_credits_sources to listOf(
                        "• A Concise Dictionary of Middle Egyptian (Raymond O. Faulkner, modernized by Boris Jegorović)",
                        "• Lezioni di epigrafia geroglifica (P. Piacentini)",
                        "• Middle Egyptian: An Introduction to the Language and Culture of Hieroglyphs (James P. Allen)",
                        "• The Story of the Shipwrecked Sailor (Christian Casey)",
                        "• The Shipwrecked Sailor (Mark-Jan Nederhof)",
                        "• Les papyrus hiératiques No. 1115, 1116 A et 1116 B de l’Ermitage Impérial à St-Pétersbourg (Wladimir Semenovich Golenischeff)",
                        "• pharaoh.se",
                        "• egyptianhieroglyphs.net"
                    ),
                    Res.string.profile_credits_image_sources to listOf(
                        stringResource(Res.string.profile_credits_image_note),
                        "• Wikimedia Commons",
                        "• The Metropolitan Museum of Art (Open Access, CC0)",
                        "• Los Angeles County Museum of Art (public domain)",
                        "• Public domain historical publications (e.g. Egypt Exploration Fund)"
                    )
                )
                creditSections.forEachIndexed { index, (sectionTitle, creditsList) ->
                    if (index > 0) {
                        HorizontalDivider(
                            color = MaterialTheme.colorScheme.outlineVariant.copy(
                                alpha = 0.5f
                            )
                        )
                    }
                    Text(
                        text = stringResource(sectionTitle),
                        style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.SemiBold),
                        color = MaterialTheme.colorScheme.primary
                    )
                    Column(
                        verticalArrangement = Arrangement.spacedBy(4.dp)
                    ) {
                        creditsList.forEach { credit ->

                            Text(
                                text = credit,
                                style = MaterialTheme.typography.bodyMedium,
                                color = MaterialTheme.colorScheme.onSurface
                            )

                        }
                    }
                }

                HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f))

                Text(
                    text = stringResource(Res.string.profile_credits_bug_reports),
                    style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.SemiBold),
                    color = MaterialTheme.colorScheme.primary
                )
                Text(
                    text = "Gregory - Nana - Dmitry - Marie - Alan - Rowan - Mordecai - LA - Luis - Zhongy - Dante - Kurt - Cyan - Greg",
                    style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Medium),
                    color = MaterialTheme.colorScheme.onSurface
                )

            }
        }

        Spacer(Modifier.height(16.dp))

        Text(
            text = "v${getAppVersionName()}",
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.5f),
            modifier = Modifier
                .align(Alignment.CenterHorizontally)
                .semantics { testTag = "profile_version_text" }
        )

        Spacer(Modifier.height(16.dp))

        if (showCheats) {
            Text(
                text = stringResource(Res.string.profile_debug_actions_title),
                style = MaterialTheme.typography.titleSmall.copy(fontWeight = FontWeight.SemiBold),
                color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.7f)
            )
            Spacer(Modifier.height(8.dp))

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = stringResource(Res.string.test_mode_title),
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                        color = MaterialTheme.colorScheme.onSurface
                    )
                    Text(
                        text = stringResource(Res.string.test_mode_desc),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                    )
                }
                Switch(
                    checked = testMode,
                    onCheckedChange = {
                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                        onTestModeToggle(it)
                    },
                    colors = SwitchDefaults.colors(
                        checkedThumbColor = MaterialTheme.colorScheme.onPrimary,
                        checkedTrackColor = MaterialTheme.colorScheme.primary,
                        uncheckedThumbColor = MaterialTheme.colorScheme.outline,
                        uncheckedTrackColor = MaterialTheme.colorScheme.surfaceVariant
                    )
                )
            }

            Spacer(Modifier.height(12.dp))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                SettingsActionButton(
                    title = stringResource(Res.string.add_stars_btn),
                    modifier = Modifier.weight(1f),
                    backgroundColor = MaterialTheme.colorScheme.secondaryContainer,
                    borderColor = MaterialTheme.colorScheme.tertiary,
                    textColor = MaterialTheme.colorScheme.onSecondaryContainer,
                    testTagId = "profile_btn_add_stars",
                    onClick = onAddStars
                )
                SettingsActionButton(
                    title = stringResource(Res.string.add_hearts_btn),
                    modifier = Modifier.weight(1f),
                    backgroundColor = MaterialTheme.colorScheme.secondaryContainer,
                    borderColor = MaterialTheme.colorScheme.tertiary,
                    textColor = MaterialTheme.colorScheme.onSecondaryContainer,
                    testTagId = "profile_btn_add_hearts",
                    onClick = onAddHearts
                )
            }
            Spacer(Modifier.height(8.dp))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                SettingsActionButton(
                    title = stringResource(Res.string.add_coins_btn),
                    modifier = Modifier.weight(1f),
                    backgroundColor = MaterialTheme.colorScheme.secondaryContainer,
                    borderColor = MaterialTheme.colorScheme.tertiary,
                    textColor = MaterialTheme.colorScheme.onSecondaryContainer,
                    testTagId = "profile_btn_add_coins",
                    onClick = onAddExperience
                )
                SettingsActionButton(
                    title = stringResource(Res.string.remove_hearts_btn),
                    modifier = Modifier.weight(1f),
                    backgroundColor = MaterialTheme.colorScheme.secondaryContainer,
                    borderColor = MaterialTheme.colorScheme.tertiary,
                    textColor = MaterialTheme.colorScheme.onSecondaryContainer,
                    testTagId = "profile_btn_remove_hearts",
                    onClick = onRemoveHearts
                )
            }

            Spacer(Modifier.height(8.dp))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                SettingsActionButton(
                    title = stringResource(Res.string.unlock_all_lessons_btn),
                    modifier = Modifier.weight(1f),
                    backgroundColor = MaterialTheme.colorScheme.secondaryContainer,
                    borderColor = MaterialTheme.colorScheme.tertiary,
                    textColor = MaterialTheme.colorScheme.onSecondaryContainer,
                    testTagId = "profile_btn_unlock_all",
                    onClick = onUnlockAllLessons
                )
                SettingsActionButton(
                    title = stringResource(Res.string.unlock_up_to_chapter_9_btn),
                    modifier = Modifier.weight(1f),
                    backgroundColor = MaterialTheme.colorScheme.secondaryContainer,
                    borderColor = MaterialTheme.colorScheme.tertiary,
                    textColor = MaterialTheme.colorScheme.onSecondaryContainer,
                    testTagId = "profile_btn_unlock_up_to_chapter_9",
                    onClick = onUnlockLessonsUpToChapter9
                )
            }

            Spacer(Modifier.height(8.dp))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                SettingsActionButton(
                    title = stringResource(Res.string.clear_wrong_answers_btn),
                    modifier = Modifier.weight(1f),
                    backgroundColor = MaterialTheme.colorScheme.errorContainer,
                    borderColor = MaterialTheme.colorScheme.error,
                    textColor = MaterialTheme.colorScheme.onErrorContainer,
                    testTagId = "profile_btn_clear_wrong_answers",
                    onClick = onClearWrongAnswers
                )
                SettingsActionButton(
                    title = stringResource(Res.string.reset_data_btn),
                    modifier = Modifier.weight(1f),
                    backgroundColor = MaterialTheme.colorScheme.errorContainer,
                    borderColor = MaterialTheme.colorScheme.error,
                    textColor = MaterialTheme.colorScheme.onErrorContainer,
                    testTagId = "profile_btn_reset",
                    onClick = { showResetDialog.value = true }
                )
            }
        }

        Spacer(Modifier.height(24.dp))
    }
}

@Composable
private fun LegalLinkBox(
    label: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    testTagId: String,
) {
    val deviceInfo = rememberDeviceInfo()
    val fontScale = LocalDensity.current.fontScale
    val hapticFeedback = LocalHapticFeedback.current
    Card(
        modifier = modifier
            .clickable(onClick = {
                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                onClick()
            })
            .semantics { testTag = testTagId },
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surface.copy(alpha = 0.75f)
        ),
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 12.dp, vertical = 10.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Text(
                text = label.replace(
                    "y P",
                    if (deviceInfo.isPhone && deviceInfo.isPortrait) "y\nP" else "y P"
                ),
                modifier = Modifier.weight(1f),
                style = MaterialTheme.typography.labelLarge.copy(fontWeight = FontWeight.Medium),
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                minLines = if (deviceInfo.isPhone && deviceInfo.isPortrait) 2 else 1,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            if (fontScale < 1.49) {
                Icon(
                    imageVector = FeatherIcons.ChevronRight,
                    contentDescription = null,
                    tint = MaterialTheme.colorScheme.onSurfaceVariant,
                    modifier = Modifier.size(16.dp)
                )
            }
        }
    }
}

@Composable
fun ProfileCtaItem(
    text: String,
    actionLabel: String,
    avatar: @Composable () -> Unit,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    testTagId: String,
) {
    Card(
        modifier = modifier
            .fillMaxWidth()
            .semantics { testTag = testTagId },
        shape = RoundedCornerShape(16.dp),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.55f)
        ),
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary.copy(alpha = 0.2f))
    ) {
        Row(
            modifier = Modifier.padding(4.dp).padding(end = 4.dp).padding(vertical = 4.dp),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            avatar()
            Text(
                modifier = Modifier.weight(1f).padding(2.dp),
                text = text,
                style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold),
                color = MaterialTheme.colorScheme.onSurface
            )
            val hapticFeedback = LocalHapticFeedback.current
            Button(
                onClick = {
                    hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                    onClick()
                },
                enabled = enabled,
                modifier = Modifier
                    .widthIn(min = 80.dp)
                    .semantics { testTag = "${testTagId}_action" },
                border = BorderStroke(
                    width = 1.dp,
                    color = MaterialTheme.colorScheme.primary.copy(alpha = 0.5f)
                ),
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.primaryContainer,
                    contentColor = MaterialTheme.colorScheme.onPrimaryContainer
                ),
                shape = RoundedCornerShape(12.dp),
                contentPadding = PaddingValues(horizontal = 10.dp, vertical = 0.dp)
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    Text(
                        text = actionLabel,
                        style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold)
                    )
                    Spacer(modifier = Modifier.width(4.dp))
                    Icon(
                        imageVector = FeatherIcons.ChevronRight,
                        contentDescription = null,
                        modifier = Modifier.size(16.dp)
                    )
                }
            }
        }
    }
}

@Composable
private fun ReminderTimeButton(
    hour: Int,
    minute: Int,
    enabled: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val safeHour = hour.coerceIn(0, 23)
    val safeMinute = minute.coerceIn(0, 59)
    val timeText = buildString {
        append(if (safeHour < 10) "0" else "")
        append(safeHour)
        append(":")
        append(if (safeMinute < 10) "0" else "")
        append(safeMinute)
    }

    val hapticFeedback = LocalHapticFeedback.current
    Button(
        enabled = enabled,
        onClick = {
            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
            onClick()
        },
        modifier = modifier
            .heightIn(min = 44.dp)
            .semantics { testTag = "profile_btn_reminder_time" },
        shape = RoundedCornerShape(12.dp),
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary.copy(alpha = 0.35f)),
        colors = ButtonDefaults.buttonColors(
            containerColor = MaterialTheme.colorScheme.surfaceVariant,
            contentColor = MaterialTheme.colorScheme.onSurfaceVariant
        ),
        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 0.dp)
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(
                text = stringResource(Res.string.reminder_settings_choose),
                style = MaterialTheme.typography.labelLarge.copy(fontWeight = FontWeight.SemiBold)
            )
            Spacer(Modifier.weight(1f))
            Text(
                text = timeText,
                style = MaterialTheme.typography.labelLarge.copy(fontWeight = FontWeight.Bold),
                color = MaterialTheme.colorScheme.primary
            )
            Icon(
                imageVector = FeatherIcons.ChevronRight,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }
    }
}

@Composable
private fun SettingsActionButton(
    title: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    backgroundColor: androidx.compose.ui.graphics.Color = MaterialTheme.colorScheme.surfaceVariant,
    borderColor: androidx.compose.ui.graphics.Color = MaterialTheme.colorScheme.outlineVariant,
    textColor: androidx.compose.ui.graphics.Color = MaterialTheme.colorScheme.onSurfaceVariant,
    testTagId: String? = null,
) {
    val hapticFeedback = LocalHapticFeedback.current
    Button(
        onClick = {
            hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
            onClick()
        },
        modifier = modifier
            .heightIn(min = 38.dp)
            .then(Modifier.semantics {
                testTag = testTagId ?: "profile_btn_${title.toTestTagToken()}"
            }),
        shape = RoundedCornerShape(12.dp),
        border = BorderStroke(1.dp, borderColor),
        colors = ButtonDefaults.buttonColors(
            containerColor = backgroundColor,
            contentColor = textColor
        ),
        contentPadding = PaddingValues(horizontal = 12.dp, vertical = 0.dp)
    ) {
        Text(
            text = title,
            modifier = Modifier.fillMaxWidth(),
            style = MaterialTheme.typography.labelLarge.copy(fontWeight = FontWeight.SemiBold),
            textAlign = TextAlign.Center,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

// Generic trigger+menu dropdown shared by the language and theme pickers in
// ProfileScreen: both used to be a row of buttons, but that stops fitting
// comfortably on one line once labels get long (e.g. French) or the option
// count grows (e.g. a 5th UI language).
@Composable
private fun <T> SettingsDropdown(
    selected: T,
    options: List<T>,
    optionLabel: (T) -> String,
    onSelect: (T) -> Unit,
    triggerTestTag: String,
    optionTestTag: (T) -> String,
    modifier: Modifier = Modifier,
) {
    val hapticFeedback = LocalHapticFeedback.current
    var expanded by remember { mutableStateOf(false) }

    Box(modifier = modifier) {
        Row(
            modifier = Modifier
                .heightIn(min = 36.dp)
                .clip(RoundedCornerShape(12.dp))
                .background(MaterialTheme.colorScheme.primary)
                .semantics { testTag = triggerTestTag }
                .clickable {
                    hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                    expanded = true
                }
                .padding(horizontal = 14.dp, vertical = 9.dp),
            horizontalArrangement = Arrangement.spacedBy(6.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = optionLabel(selected),
                style = MaterialTheme.typography.labelLarge.copy(fontWeight = FontWeight.SemiBold),
                color = MaterialTheme.colorScheme.onPrimary,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = "▾",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.onPrimary
            )
        }

        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false }
        ) {
            options.forEach { option ->
                DropdownMenuItem(
                    text = { Text(optionLabel(option)) },
                    onClick = {
                        hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                        onSelect(option)
                        expanded = false
                    },
                    modifier = Modifier.semantics { testTag = optionTestTag(option) }
                )
            }
        }
    }
}

// Supported UI language codes, in display order.
private val SUPPORTED_LANGUAGE_CODES = listOf("it", "en", "de", "es", "fr")

@Composable
private fun LanguageDropdown(
    selectedLanguage: String,
    onLanguageChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    languageCodes: List<String> = SUPPORTED_LANGUAGE_CODES,
) {
    val selectedCode =
        languageCodes.firstOrNull { selectedLanguage.startsWith(it) } ?: languageCodes.first()
    SettingsDropdown(
        selected = selectedCode,
        options = languageCodes,
        optionLabel = { it.uppercase() },
        onSelect = onLanguageChange,
        triggerTestTag = "profile_language_dropdown_trigger",
        optionTestTag = { "profile_btn_language_$it" },
        modifier = modifier
    )
}

@Composable
private fun ThemeModeDropdown(
    selectedTheme: ThemeMode,
    onThemeModeChange: (ThemeMode) -> Unit,
    modifier: Modifier = Modifier,
) {
    val labels = mapOf(
        ThemeMode.System to stringResource(Res.string.profile_theme_system),
        ThemeMode.Light to stringResource(Res.string.profile_theme_light),
        ThemeMode.Dark to stringResource(Res.string.profile_theme_dark)
    )
    SettingsDropdown(
        selected = selectedTheme,
        options = listOf(ThemeMode.System, ThemeMode.Light, ThemeMode.Dark),
        optionLabel = { labels.getValue(it) },
        onSelect = onThemeModeChange,
        triggerTestTag = "profile_theme_dropdown_trigger",
        optionTestTag = { "profile_btn_theme_${it.storageValue}" },
        modifier = modifier
    )
}

private fun String.toTestTagToken(): String {
    return lowercase()
        .replace(" ", "_")
        .replace(Regex("[^a-z0-9_]+"), "")
        .ifBlank { "default" }
}

